import {SxProps, Theme} from '@mui/material/styles';

/**
 * Match C Section InputField look (default outlined chrome, no Excel yellow).
 * Kept as named exports so call sites stay consistent if theme tweaks are needed later.
 */
export const yellowFieldSx: SxProps<Theme> = {};

export const yellowReadonlySx: SxProps<Theme> = {
    '& .MuiOutlinedInput-input': {
        cursor: 'default',
    },
};
